<template>
  <AnalysisLayout>
    <router-view />
  </AnalysisLayout>
</template>

<script>
import AnalysisLayout from '@/components/templates/AnalysisLayout'

export default {
  name: 'Analysis',
  components: {
    AnalysisLayout,
  },
}
</script>
